import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HelpdeskService } from '../delavci/helpdesk.service';
import { MainService } from '../delavci/main.service';
import { LoginPartnerService } from '../partner/login-partner/login-partner.service';
import { map, catchError } from 'rxjs/operators';
import { timeParser } from 'src/app/utils/timeParser';
import { timeParserOneElement } from 'src/app/utils/timeParserOneElement';

@Injectable({
  providedIn: 'root'
})
export class AuthUrediTaskGuard  {

  public id;
  public bool;
  constructor(private loginPartnerService: LoginPartnerService, private mainService: MainService,
    private helpdeskService: HelpdeskService, private route: ActivatedRoute, private router: Router ) {

    }

  canActivate(
    next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      if(this.loginPartnerService.currentPartnerValue != null || this.mainService.currentUserValue != null ) {
        this.id = next.paramMap.get('idTask');
        return  this.helpdeskService.getHelpdeskTaskById(this.loginPartnerService.currentSessionValue, this.mainService.currentUserValue,
          this.loginPartnerService.currentPartnerValue, this.id).pipe(
            map(res => {
                if (res.data.tasks.length > 0) {
                this.helpdeskService.changeDataRow(timeParserOneElement(res.data.tasks[0]));
                return true;
              } else {
                alert("Ta id na tem računu ne obstaja!");
                return false;
              }
            }),
            catchError((err) => {
              return of(false);
            })
          );
      } else {
        this.router.navigate(['/login-partner'], { queryParams: { returnUrl: state.url }});
        return false;
      }

  }

}
